import React from 'react';
import { useTranslation } from 'react-i18next';
import Text from 'components/Text';

const SoldOut = () => {
    const { t } = useTranslation();

    return (
        <Text as="p" typography="Content/18_150_0_350">
            <span dangerouslySetInnerHTML={{ __html: t('pdp.sold_out.text') }} />
        </Text>
    );
};

export default SoldOut;
